import { Button } from '@fairygodboss/ui';
import axios from 'axios';
import React from 'react';

import PopUp from '../../../Elements/PopUp';
import Icon from '../../../Images/Icons/Icon';

export default class AdminMenu extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showMenu: true,
            showConfirmation: false,
            msg: '',
        };
    }

    callManagementApi = (url, action) => {
        const apiCallFunc = axios[action];
        apiCallFunc(url)
            .then((res) => this.setState({
                msg: res.data.msg,
                showConfirmation: true,
                showMenu: false,
            }))
            // eslint-disable-next-line no-console
            .catch(console.error);
    };

    renderTitle = () => {
        const title = this.props.hash
            ? this.props.hash.split('-').join(' ')
            : '';
        return (
            <div className="title">{`Manage ${this.props.type}: ${title}`}</div>
        );
    };

    renderMenuItems = () => (
        <ul className="admin-menu">
            <style jsx global>
                {`
                    .btn-outline-primary {
                        background-color: transparent;
                        background-image: none;
                        border-color: #a234b2;
                        font-size: 16px;
                        color: #a234b2;
                    }
                    .btn-outline-primary:hover {
                        background-color: #a234b2;
                        border-color: #a234b2;
                        color: #fff;
                    }
                    .btn-outline-primary:hover a {
                        color: #fff !important;
                    }
                    .btn-outline-primary:active {
                        background-color: #a234b2;
                        border-color: #a234b2;
                        color: #fff;
                    }
                    .btn-outline-primary a {
                        color: #a234b2 !important;
                        text-decoration: none;
                    }
                    .btn-outline-primary a:hover {
                        color: #fff !important;
                    }
                    .btn-outline-primary a:active {
                        color: #a234b2;
                    }
                `}
            </style>
            {this.renderTitle()}
            {this.props.adminMenu.map((menuItem) => (
                <Button
                    type="button"
                    variant="primary"
                    className="link btn btn-outline-primary new-outline"
                    key={menuItem.name}
                    onPress={() => this.callManagementApi(menuItem.url, menuItem.action)}
                    onKeyPress={() => this.callManagementApi(menuItem.url, menuItem.action)}
                >
                    {menuItem.name}
                </Button>
            ))}
            <Button variant="primary" className="link btn btn-outline-primary">
                <a href={this.props.cmsLink} target="_blank" rel="noreferrer">
                    View In CMS
                </a>
            </Button>
        </ul>
    );

    renderConfirmation = () => (
        <div>
            <div className="title align-items-center p-5">{this.state.msg}</div>
            <div
                className="link text-right underline"
                onClick={() => this.setState({ showMenu: true, showConfirmation: false })}
                onKeyPress={() => this.setState({ showMenu: true, showConfirmation: false })}
                tabIndex={0}
                role="button"
            >
                Back to Menu
            </div>
        </div>
    );

    onClose = () => {
        this.props.closeAdminMenu();
        this.setState({ showMenu: true, showConfirmation: false });
    };

    render() {
        const btn = this.props.showMenuIcon && (
            <div
                className="pt-1 pl-2"
                onClick={this.props.toggleAdminMenu}
                onKeyPress={this.props.toggleAdminMenu}
                tabIndex={0}
                role="button"
            >
                <Icon name="dotdotdot" bgColor="white-bg" size="xsmall" />
            </div>
        );

        return (
            <div className="Admin-menu">
                <style jsx>
                    {`
                        .Admin-menu .title {
                            max-width: 400px;
                            margin: 10px;
                        }
                        .Admin-menu ul {
                            padding: 0;
                            margin: 1rem;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }
                        .Admin-menu .link {
                            margin: 10px;
                            padding: 5px;
                            width: 240px;
                        }
                        .Admin-menu .link:focus {
                            outline: none;
                        }
                        .Admin-menu .link:hover a,
                        .Admin-menu .link a:hover {
                            color: white;
                        }
                        .Admin-menu .pt-1:focus {
                            outline: none;
                        }
                    `}
                </style>
                {btn}
                <PopUp
                    showPopUp={this.props.openAdminMenu}
                    showOverlay
                    clickOutside
                    className="fixed"
                    cancel={this.onClose}
                    showLogo={false}
                    minWidth="360px"
                    hideCloseButton
                >
                    {this.state.showMenu ? this.renderMenuItems() : null}
                    {this.state.showConfirmation
                        ? this.renderConfirmation()
                        : null}
                </PopUp>
            </div>
        );
    }
}
